import { useMemo, FocusEvent } from 'react';
import { UiSelect } from '@frontend/znanie-uikit';

import { useCategories } from 'hooks/categories/useCategories';

import { CategoryType } from 'graphql/types';

import css from './CategoriesDropdown.module.scss';

interface IProps {
  formik: any;
  field: string;
  placeholder: string;
  tabIndex?: string;
  label?: string;
  isCustomOption?: boolean;
  onChange(opt: any): void;
  onBlur(e: FocusEvent<HTMLElement>): void;
}

export default function CategoriesDropdown({
  formik,
  field,
  label,
  placeholder,
  tabIndex = '1',
  onChange,
  onBlur,
  isCustomOption,
}: IProps) {
  const { values, touched, errors } = formik;
  const { data: categoriesData } = useCategories();

  const categoriesList = useMemo(
    () => (categoriesData?.categories as CategoryType[]) || [],
    [categoriesData]
  );
  const categoriesOptions = useMemo(
    () =>
      categoriesList.length > 0
        ? categoriesList.map((c) => ({
            value: c.id,
            label: c.name as string,
            description: c.description,
          }))
        : [],
    [categoriesList]
  );

  return (
    <UiSelect
      id={field}
      instanceId={field}
      name={field}
      tabIndex={Number(tabIndex)}
      label={label}
      placeholder={placeholder}
      isSearchable={false}
      noOptionsMessage={() => 'Ничего не найдено'}
      options={categoriesOptions}
      value={values[field]}
      onChange={onChange}
      isCustomOption={isCustomOption}
      onBlur={onBlur}
      errorLabel={touched[field] && errors[field]}
      formatOptionLabel={({ label, description }: any) => (
        <div className={css.option}>
          {label} <span>({description})</span>
        </div>
      )}
    />
  );
}
